import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { SiteNav } from '../components/SiteNav'
import { setPageMeta } from '../utils'

const POSTS = [
  {
    slug: 'does-chatgpt-store-your-conversations',
    title: 'Does ChatGPT Store Your Conversations?',
    description: 'What OpenAI actually does with the text you paste into ChatGPT, who can see it, and how to limit data retention.',
    date: '2026-01-15',
    readTime: '5 min read',
  },
  {
    slug: 'what-happens-to-data-you-paste-into-claude',
    title: 'What Happens to Data You Paste into Claude?',
    description: "Anthropic's data practices explained: what Claude stores, who can see it, and how it compares to ChatGPT.",
    date: '2026-02-15',
    readTime: '5 min read',
  },
  {
    slug: 'how-to-use-ai-safely-with-confidential-documents',
    title: 'How to Use AI Safely with Confidential Documents',
    description: 'A practical guide for legal, finance, and healthcare professionals who need to use AI tools without exposing sensitive data.',
    date: '2026-01-18',
    readTime: '6 min read',
  },
  {
    slug: 'agentic-ai-and-the-data-privacy-problem',
    title: 'Agentic AI and the Data Privacy Problem',
    description: 'When AI acts autonomously on your behalf, you lose control over what data it accesses and transmits. What that means for professionals handling sensitive information.',
    date: '2026-02-19',
    readTime: '6 min read',
  },
]

export function BlogPage() {
  useEffect(() => {
    setPageMeta({
      title: 'Blog | arisk.ai',
      description: 'Guides and explainers on AI privacy: what AI tools do with your data and how to protect sensitive information.',
      canonical: 'https://arisk.ai/blog',
    })
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-neutral-900 text-gray-800 dark:text-neutral-200">
      <SiteNav />

      {/* Content */}
      <div className="max-w-2xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Blog</h1>
        <p className="text-gray-500 dark:text-neutral-400 mb-12">
          Guides and explainers on AI privacy: what AI tools do with your data and how to stay in control.
        </p>

        <div className="divide-y divide-gray-200 dark:divide-neutral-700">
          {[...POSTS].sort((a, b) => b.date.localeCompare(a.date)).map((post) => (
            <article key={post.slug} className="py-6">
              <div className="flex items-center gap-3 text-xs text-gray-400 dark:text-neutral-500 mb-2">
                <time dateTime={post.date}>{post.date}</time>
                <span>·</span>
                <span>{post.readTime}</span>
              </div>
              <h2 className="text-base font-semibold mb-1">
                <Link
                  to={`/blog/${post.slug}`}
                  className="text-gray-900 dark:text-white hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  {post.title}
                </Link>
              </h2>
              <p className="text-sm text-gray-500 dark:text-neutral-400 leading-relaxed">
                {post.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}
